var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-admin-layout',[_c('template',{slot:"title"},[_c('b-icon',{attrs:{"icon":"chat-right-text"}}),_vm._v("Forum Topics")],1),_c('r-admin-card',{attrs:{"title":"Topic Information"}},[(_vm.loaded)?_c('r-topic-form',{attrs:{"onSubmit":_vm.submitted,"onRemove":_vm.removed,"topic":_vm.topic}}):_vm._e()],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }